import { render, staticRenderFns } from "./SidebarTabBacklinks.vue?vue&type=template&id=9ff3b86a&scoped=true"
import script from "./SidebarTabBacklinks.vue?vue&type=script&lang=js"
export * from "./SidebarTabBacklinks.vue?vue&type=script&lang=js"
import style0 from "./SidebarTabBacklinks.vue?vue&type=style&index=0&id=9ff3b86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff3b86a",
  null
  
)

export default component.exports